import { withStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Loader from "components/loader/Loader";
import { formatDate } from "helper/dateFormat";
import React from "react";
import { NameWrapper, StatusWrapper } from "./Theme";
import { fontConfig } from "theme/fontConfig";

export const CampaignDetailsList = ({
  rows,
  setPage,
  page,
  loading,
  count,
  campaignType,
}) => {
  const isPushCampaign = campaignType === "push";
  const headerTitles = [
    "Name",
    "Sent",
    "Opened",
    ...(isPushCampaign ? [] : ["Unsubscribe"]),
    "Clicked",
    "Bounced",
    "Status",
  ];
  const TableCellHead = withStyles((theme) => ({
    root: {
      height: "39px",
      padding: "0px 20px",
      borderBottom: "none",
      fontFamily: fontConfig.GeneralTableCellHeadFont.family,
      fontSize: "15px",
      fontWeight: "bold",
      lineHeight: "25.6px",
      color: "#404253",
      paddingTop: "10px",
    },
  }))(TableCell);
  const TableCellBody = withStyles((theme) => ({
    root: {
      height: "65px",
      padding: "0px 20px",
      fontFamily: fontConfig.GeneralTableCellBodyFont.family,
      fontSize: 12,
      fontWeight: 400,
    },
  }))(TableCell);

  let statusClassName;

  // Determine the CSS class based on the status
  const statusColor = (status) => {
    switch (status) {
      case "open":
        return { backgroundColor: "#70cb8047", color: "#81DC91" };
      case "not open":
        return { backgroundColor: "#ffce7eb5", color: "orange" };
      case "unsubscribed":
        return { backgroundColor: "rgb(250 51 114 / 20%)", color: "#FA3372" };
      case "bounced":
        return { backgroundColor: "#d8d3d3", color: "#8E8E8E" };
      default:
        statusClassName = "";
    }
  };
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          height: "70%",
          boxShadow: "0 0 50px 0 rgba(82, 63, 105, 0) !important",
        }}
      >
        <Table
          sx={{
            [`& .${tableCellClasses.root}`]: {
              borderBottom: "none",
            },
          }}
          aria-label="collapsible table"
        >
          <TableHead>
            {headerTitles.map((item) => (
              <TableCellHead className="class__header__cell className_head">
                {item}
              </TableCellHead>
            ))}
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCellBody colSpan={10} align="center">
                  <div className="user__loader" style={{ height: "320px" }}>
                    <Loader />
                  </div>
                </TableCellBody>
              </TableRow>
            ) : rows?.length === 0 ? (
              <TableRow>
                <TableCellBody colSpan={10} align="center">
                  <h6 style={{ height: "320px", marginTop: "100px" }}>
                    No Campaigns Found
                  </h6>
                </TableCellBody>
              </TableRow>
            ) : (
              rows?.map((row) => (
                <TableRow
                  key={row?._id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCellBody
                    style={{
                      whiteSpace: "normal",
                      minWidth: "150px",
                    }}
                      className="main-width-class"
                    align="left"
                  >
                    <NameWrapper>
                      <Stack direction="row" spacing={2}>
                        <Avatar
                          alt="Remy Sharp"
                          src={row?.contact?.profile_img}
                        />
                      </Stack>
                      <span>{`${row?.contact?.first_name} ${row?.contact?.last_name}`}</span>
                    </NameWrapper>
                  </TableCellBody>
                  <TableCellBody
                    style={{
                      whiteSpace: "normal",
                      minWidth: "150px",
                    }}
                    className="main-width-class"

                    align="left"
                  >
                    {row?.createdAt
                      ? formatDate({date:row?.createdAt, formatType: "defaultWithTime"})
                      : "-"}
                  </TableCellBody>
                  <TableCellBody
                    style={{
                      minWidth: "150px",
                      whiteSpace: "normal",
                    }}
                    align="left"
                  >
                    {row?.opened
                      ? formatDate({date:row?.opened, formatType: "defaultWithTime"})
                      : "-"}
                  </TableCellBody>
                  {!isPushCampaign && (
                    <TableCellBody
                      style={{
                        minWidth: "150px",
                        whiteSpace: "normal",
                      }}
                      align="left"
                    >
                      {row?.unsubscribed
                        ? formatDate({date:row?.unsubscribed, formatType: "defaultWithTime"})
                        : "-"}
                    </TableCellBody>
                  )}
                  <TableCellBody
                    style={{
                      minWidth: "150px",
                      whiteSpace: "normal",
                    }}
                    align="left"
                  >
                    <StatusWrapper style={statusColor(row?.status)}>
                       {row?.clicked
                      ? formatDate({date:row?.clicked, formatType: "defaultWithTime"})
                      : "-"}
                    </StatusWrapper>
                  </TableCellBody>
                  <TableCellBody
                    style={{
                      minWidth: "150px",
                      whiteSpace: "normal",
                    }}
                    align="left"
                  >
                      {row?.bounced}
                  </TableCellBody>
                  <TableCellBody
                    style={{
                      minWidth: "150px",
                      whiteSpace: "normal",
                    }}
                    align="left"
                  >
                    {row?.status}
                  </TableCellBody>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {rows?.length > 0 && (
        <div className="pagination-custom mt-9">
          <Pagination
            count={Math.ceil(count / 10)}
            color="primary"
            variant="outlined"
            page={page + 1}
            onChange={(event, value) => {
              setPage(value - 1);
            }}
          />
        </div>
      )}
    </>
  );
};
